import script from "./ViewGoToRound.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGoToRound.vue?vue&type=script&setup=true&lang=js"

import "./ViewGoToRound.vue?vue&type=style&index=0&id=65c20bf1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c20bf1"]])

export default __exports__